"use client";

import type { PatientDto } from "@repo/data-store";
import { Field, FieldError, FieldLabel } from "@repo/ui/form-fields";
import { useFieldContext } from "@/shared/forms/form-context";
import { PatientPicker } from "@/shared/pickers/patient-picker";

export interface PatientFieldProps {
  label?: string;
  placeholder?: string;
  patients: PatientDto[];
  disabled?: boolean;
  isLoading?: boolean;
}

export function PatientField({ label, placeholder, patients, disabled, isLoading }: PatientFieldProps) {
  const field = useFieldContext<string | undefined>();

  return (
    <Field errors={field.state.meta.errors} isTouched={field.state.meta.isTouched}>
      {label && <FieldLabel>{label}</FieldLabel>}
      <PatientPicker
        value={field.state.value}
        onChange={field.handleChange}
        onBlur={field.handleBlur}
        patients={patients}
        placeholder={placeholder}
        disabled={disabled}
        isLoading={isLoading}
        className={label ? "mt-1" : ""}
      />
      <FieldError />
    </Field>
  );
}
